"use client";

import { ShieldCheck } from "@/components/ui/icons";

type LoginAdminButtonProps = {
  disabled: boolean;
  onClick: () => void;
};

export function LoginAdminButton({
  disabled,
  onClick,
}: LoginAdminButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Admin access"
      title="Admin access"
      className={
        "theme-button-secondary theme-login-admin-button inline-flex h-[3rem] w-[3rem] items-center justify-center rounded-[var(--radius-sm)] border p-0 transition-[transform,background,color,border-color,box-shadow,opacity] duration-200 hover:-translate-y-px focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[color:var(--color-ring)] disabled:opacity-70 sm:h-[3.15rem] sm:w-[3.15rem]"
      }
    >
      <ShieldCheck className={"h-[1.15rem] w-[1.15rem] sm:h-[1.3rem] sm:w-[1.3rem]"} aria-hidden="true" />
    </button>
  );
}
